var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "form", attrs: { name: "form" } },
    [
      _c("e-sidebar", {
        attrs: {
          id: "sidebar-stock-counting",
          title: _vm.$t("Nova Contagem de Estoque"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: {
          save: _vm.onSaveCounting,
          hidden: function ($event) {
            _vm.showSidebar = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("e-store-combo", {
                          attrs: { required: "", "only-active-options": true },
                          model: {
                            value: _vm.form.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "storeId", $$v)
                            },
                            expression: "form.storeId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "counting-description",
                            type: "textarea",
                            label: _vm.$t("Descrição"),
                          },
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "product-group-id",
                            label: _vm.$t("Grupo"),
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboGroups,
                          },
                          on: { input: _vm.onGroupChange },
                          model: {
                            value: _vm.form.groupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "groupId", $$v)
                            },
                            expression: "form.groupId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "product-subgroup-id",
                            type: "vue-select",
                            label: _vm.$t("Subgrupo"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboSubgroups,
                            disabled: !_vm.form.groupId,
                          },
                          model: {
                            value: _vm.form.subgroupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "subgroupId", $$v)
                            },
                            expression: "form.subgroupId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "product-brand-id",
                            label: _vm.$t("Marca"),
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboBrands,
                          },
                          model: {
                            value: _vm.form.brandId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "brandId", $$v)
                            },
                            expression: "form.brandId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "product-department-id",
                            label: _vm.$t("Departamento"),
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboDepartments,
                          },
                          model: {
                            value: _vm.form.departmentId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "departmentId", $$v)
                            },
                            expression: "form.departmentId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            name: "productClassifications",
                            type: "vue-select",
                            label: _vm.$t("Classificações de produto"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.productClassificationsForInventory(),
                            instruction: _vm.$t(
                              "Selecione uma ou mais classificações de produtos"
                            ),
                            multiple: "",
                          },
                          model: {
                            value: _vm.form.productClassifications,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "productClassifications", $$v)
                            },
                            expression: "form.productClassifications",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }